
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concepts-overview",
      function () {
        return require("private-next-pages/concepts-overview/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concepts-overview"])
      });
    }
  